import { Box, Container, Typography, styled } from '@mui/material'
import { useLocation } from 'react-router'
import InterSlider from './animations/InternalSlider'
import ShareIcon from './icons/ShareIcon'

const CustomBox = styled('div')(({ theme }) => ({
  marginLeft: '24px',
  display: 'flex',
  alignItems: 'flex-end',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(7)
  },
  [theme.breakpoints.down('lg')]: {
    paddingLeft: theme.spacing(16)
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: '20px'
  }
}))

const BodyBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  [theme.breakpoints.up('md')]: {
    marginLeft: '24px'
  },
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 0,
    display: 'none'
  }
}))

export default function Header({ title, type }: { title?: string; type?: number }) {
  const location = useLocation()

  let noShare = ['/escritorio', '/usuarios/perfil', '/favoritos', 'admin'].includes(location.pathname)
  let isHidden = ['/comercial', '/favoritos'].includes(location.pathname)
  return (
    <BodyBox>
      <InterSlider isHidden={isHidden} />
      {type === 1 ? (
        <></>
      ) : (
        <>
          <Container
            maxWidth="xl"
            sx={theme => ({
              padding: 0,
              [theme.breakpoints.down('md')]: {
                display: 'none'
              }
            })}
          >
            <Box display="flex" flexDirection="column" gap={2} pb={2} pt={2}>
              <CustomBox>
                <Typography variant="h2" sx={theme => ({ color: theme.palette.common.white, fontWeight: 300, letterSpacing: '-0.005em' })}>
                  {' '}
                  {title}
                </Typography>
                {noShare ? (
                  <></>
                ) : (
                  <ShareIcon
                    meta={true}
                    light={true}
                    visibility={0}
                    title={'Biblioteca'}
                    description={'Biblioteca'}
                    link={window.location.href}
                    multimedia={``}
                    component="button"
                    type="resource"
                  />
                )}
              </CustomBox>
            </Box>
          </Container>
        </>
      )}
    </BodyBox>
  )
}
